import React from 'react';
import { withRouter } from 'react-router'
import Layout from './Layout';
import './MenuItemLayout.css';

import { dot } from '../../lib/obj';

class MenuItemLayout extends Layout {
  constructor(props) {
    super(props);
    // Set the initial state
    this.state = {
      expanded: this.props.expanded == "true" ? true : false
    };
  }

  onClick(history) {
    const app = this.props.app;
    const isParent = this.props.items?.length > 0;
    if (this.props.url && (!isParent || dot(app,"screen.type") == "desktop")) {
      if (this.props.onNavigate) {
        this.props.onNavigate();
      }
      this.props.history.push(this.props.url);
    } else {
      this.setState({expanded:!this.state.expanded})
    }
  }

  render() {
    let activePath = this.props.activePath;
    let isActiveParent;
    walkPath(this.props.items, (item) => {
      isActiveParent = isActivePath(item.url, activePath);
      return !isActiveParent;
    });
    let isActive = !isActiveParent && isActivePath(this.props.url, activePath);

    let sub = <div/>;
    if (this.props.items) {
      sub = <div className="Nested">
        {this.props.items.map((item, index)=>{
          return <RoutedMenuItemLayout activePath={this.props.activePath} key={`item${index}`} onNavigate={this.props.onNavigate} {...item}/>
        })}
      </div>
    }

    // Check if is active
    return (
      <div className="MenuItemLayout" ref="root" data-expanded={this.state.expanded} data-active={isActive} data-active-parent={isActiveParent}>
        <button className="Link" onClick={(history)=>{this.onClick(history)}}>
          <div className="Icon">{this.props.icon}</div>
          <div className="Label">{this.props.label}</div>
        </button>
        {sub}
      </div>
    );
  }
}

const isActivePath = (url, activePath) => {
  return activePath && url && (url === activePath || activePath.indexOf(url+"/") === 0);
}

const walkPath = (items, cb)=>{
  if (!items) { return; }
  for (var i = 0; i < items.length; i++) {
    let item = items[i];
    if (cb(item) === false ) { break; }
    walkPath(item.items, cb);
  }
};


const RoutedMenuItemLayout = withRouter(MenuItemLayout)
export default RoutedMenuItemLayout;
